import { useNavigate } from 'react-router-dom';

import { paths } from '@/app/router/paths';
import { useCreateProjectStore } from '@/features/projects/create-project/store/use-create-project-store';
import { FlowHeader } from '@/shared/components/flow/flow-header';

export const CreateProjectHeader = ({
  children,
}: {
  children?: React.ReactNode;
}) => {
  const navigate = useNavigate();

  return (
    <FlowHeader
      onCancel={() => {
        useCreateProjectStore.getState().reset();
        navigate(paths.projects.hub.path);
      }}
    >
      {children}
    </FlowHeader>
  );
};
